import { removeAuthHeader, setAuthHeader } from "../../api";
import {
  removeLocalStorageAccessToken,
  removeLocalStorageItem,
  removeLocalStorageRefreshToken,
  setLocalStorageAccessToken,
  setLocalStorageRefreshToken,
} from "./localStorage";
import { jwtDecode } from "jwt-decode";
import { getLocalStorageAccessToken } from "utils/helpers/localStorage";

export const isTokenValid = (
  token: string | null = getLocalStorageAccessToken()
): boolean => {
  if (!token) return false;

  try {
    const { exp, email } = jwtDecode<{ exp: number; email: string }>(token);
    if (!exp) return false;
    if (!email) return false;
    const expiration = exp * 1000;
    return expiration - Date.now() > 0;
  } catch {
    return false;
  }
};

export function setAuthTokens({
  accessToken,
  refreshToken,
}: {
  accessToken: string;
  refreshToken: string;
}) {
  setAuthHeader(accessToken);
  setLocalStorageAccessToken(accessToken);
  setLocalStorageRefreshToken(refreshToken);
}

export function removeAuthTokens() {
  removeAuthHeader();
  removeLocalStorageAccessToken();
  removeLocalStorageRefreshToken();
  removeLocalStorageItem("loginState");
}
